module.exports = __webpack_public_path__ + "static/media/541d2506-9363-4c8b-8646-cfbf6fa7031e.d942515d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/541d2506-9363-4c8b-8646-cfbf6fa7031e.pdf
// module id = 2566
// module chunks = 1